export default __webpack_public_path__ + "static/media/4.7213b2d3.jpg";